<media-holder [media]="media"></media-holder>
